<template>
    <div class="home-body">
        <img class="home-bg" src="@/assets/img/home_bg.png" alt="">
        <div class="home-content">
            <div class="home-content-body">
                <a-row>
                    <a-col :span="8" v-for="(item,index) in dept_list" :key="index">
                        <router-link :to="'/resource/list/video?dept_id=' + item.dept_id">
                            <div class="dept-box">
                                <div class="dept-number">
                                    {{ item.total }}
                                </div>
                                <div class="dept-name">
                                    {{ item.name }}
                                </div>
                            </div>
                        </router-link>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        defineComponent,
        ref,
        onMounted,
        // reactive
    } from "vue";

    import * as Api from "@/views/manage/api";

    export default defineComponent({
        components: {},
        setup() {
            const dept_list = ref([]);

            // 初始化
            onMounted(() => {
                Api.dept_list().then((res) => {
                    if (res.status == 200) {
                        dept_list.value = res.data.list;
                    }
                });
            });

            return {
                dept_list
            };
        },
    });
</script>

<style scoped lang="less">
    .home-body {
        padding-top: 100px;
        background-color: #ECECEC;
        height: 100vh;
        .home-bg {
            width: 100%;
        }

        .home-content {
            .home-content-body {
                width: 80%;
                margin: 0 auto;
                background-color: #fff;
                padding: 50px;
                margin-top: -200px;
                position: relative;
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                .dept-box{
                    display: block;
                    text-align: center;
                    margin-bottom: 50px;
                    .dept-number{
                        display: inline-block;
                        width: 60px;
                        height: 60px;
                        line-height: 60px;
                        text-align: center;
                        border-radius: 50%;
                        font-size: 18px;
                        border: 1px solid #7D1A15;
                        color: #7D1A15;
                        font-weight: bold;
                        margin-bottom: 10px;
                    }
                    .dept-name{
                        color: #7D1A15;
                        font-size: 16px;
                    }
                }
            }
        }
    }
</style>